export default __webpack_public_path__ + "static/media/grub.541aafc9.jpg";